// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQbjuXH_1mBBfN7-0LLnSKI_EN0_BYobc",
  authDomain: "hms-v1-33bbc.firebaseapp.com",
  projectId: "hms-v1-33bbc",
  storageBucket: "hms-v1-33bbc.appspot.com",
  messagingSenderId: "603130356881",
  appId: "1:603130356881:web:5477ddf49c5aa5ccdc0b30",
  measurementId: "G-M4L4PK7TVT",
  databaseURL:
    "https://hms-v1-33bbc-default-rtdb.asia-southeast1.firebasedatabase.app/",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
